import "@/App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import MineOrdrarPage from "@/pages/MineOrdrarPage";
import OrdrarPage from "@/pages/OrdrarPage";
import OrdreDetaljPage from "@/pages/OrdreDetaljPage";
import TilKontrollPage from "@/pages/TilKontrollPage";
import FaktureringPage from "@/pages/FaktureringPage";
import RegisterPage from "@/pages/RegisterPage";
import MeirPage from "@/pages/MeirPage";
import OrderEditorPage from "@/pages/OrderEditorPage";
import OmSystemetPage from "@/pages/OmSystemetPage";

const FullPageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="app-loading">
    Lastar …
  </div>
);

const RequireAuth = () => {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
};

const RequireAdmin = () => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/mine-ordrar" replace />;
  return <Outlet />;
};

const HomeRedirect = () => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isAdmin ? "/ordrar" : "/mine-ordrar"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomeRedirect />} />
          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route path="/mine-ordrar" element={<MineOrdrarPage />} />
              <Route path="/ordrar" element={<OrdrarPage />} />
              <Route path="/ordrar/:orderId" element={<OrdreDetaljPage />} />
              <Route path="/meir" element={<MeirPage />} />
              <Route path="/om-systemet" element={<OmSystemetPage />} />
              <Route element={<RequireAdmin />}>
                <Route path="/ordrar/ny" element={<OrderEditorPage />} />
                <Route path="/ordrar/:orderId/endre" element={<OrderEditorPage />} />
                <Route path="/til-kontroll" element={<TilKontrollPage />} />
                <Route path="/fakturering" element={<FaktureringPage />} />
                <Route path="/register" element={<RegisterPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors={false} closeButton visibleToasts={3} />
    </AuthProvider>
  );
}

export default App;
